/* PortalStarted view */
import React from 'react';
import { Loading } from "seed/helpers";
import l from "components/util/l";
import "styles/css/agent/Start.css";


const PortalStartedView = ({
  isLoading,
  onboardingFlow,
}) => {

  if (isLoading)
    return <div className="h-100"><Loading /></div>;

  if (!onboardingFlow)
    return (
      <div className="h-100 d-flex justify-content-center align-items-center px-4">
        <p className="text-muted mb-0 text-center">
          {l("El asistente no está disponible por ahora%PT001")}
        </p>
      </div>
    );

  return (
    <iframe
      className="portal-assistant-frame"
      title={l("Asistente de onboarding%PT002")}
      src={`/onboarding/${onboardingFlow.token}`}
    />
  );

}

export default PortalStartedView;
